import { redirect } from "@tanstack/react-router";
import { AuthStatus } from "@/common/enums/enums";
import { useAuthStore } from "@/store/auth.store";

interface RequireAuthParameters {
  location: Location;
}

export const protectedRoute = ({
  location,
}: RequireAuthParameters): void | ReturnType<typeof redirect> => {
  const { authStatus } = useAuthStore.getState();
  if (authStatus === AuthStatus.UNAUTHENTICATED) {
    return redirect({
      to: "/",
      search: {
        redirect: location.href,
      },
    });
  }

  return undefined;
};
